module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a4-2-b30efa75f2f8293abb17cab140d98eb5.jpg";